<script>
import { BModal } from 'bootstrap-vue';
import { momentTz } from '@/libs/utils/time';
import { title } from '@core/utils/filter';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  name: 'AccountMergeSelection',
  components: { BModal },
  props: {
    isMergeOpen: { type: Boolean, default: false },
    targetId: { type: String, required: true },
    studentId: { type: String, required: true },
  },
  data() {
    return {
      referenceAccounts: [],
    };
  },
  methods: {
    async retrieveAccounts() {
      try {
        const response = await this.$store.dispatch('receivableStoreModule/fetchAccounts', {
          page: 1,
          limit: 100,
          student: this.studentId,
          populate: 'cohort',
          sortBy: 'createdAt:desc',
        });
        const results = response.data.results;

        if (results.length === 0) {
          return;
        }

        this.referenceAccounts = results.map((account) => {
          const cohortDisplay = account.cohort
            ? `${account.cohort.startDate ? momentTz(account.cohort.startDate).format('MMM Do YYYY') : ''} ${account.cohort.name}`
            : 'Unassign';
          const createdAtRendered = momentTz(account.createdAt).format('MMM Do YYYY');
          return {
            label: `${cohortDisplay} - ${createdAtRendered} - ${title(account.status)}`.trim(),
            value: account.id,
          };
        });
      } catch (error) {
        console.error('failed to do account retrieval', error);
        return [];
      }
    },
    async onAccountSelect(originId, event) {
      if (event) event.preventDefault();

      console.log('> merging account: ', originId, 'into', this.targetId);

      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'This action will transfer all payments & charges from the account just selected, into the one initially selected.',
        // text: 'This action will transfer all information from the profile you selected to the one you are currently viewing. This action is irreversible.',
        // text: 'This will overwrite the selected profile with the one you are currently viewing.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, merge!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store
          .dispatch('receivableStoreModule/mergeAccounts', {
            targetId: this.targetId,
            originId,
          })
          .then((response) => {
            this.$emit('update:is-account-merge-open', false);

            this.$swal({
              icon: 'success',
              title: 'Merged!',
              text: 'The selected account has been migrated and deleted!',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            });

            const { id } = response.data;
            this.$router.push({ name: 'apps-accounting-receivable-account-edit', params: { id } });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Failed to merge accounts.',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: error.response ? error.response.data.message : error.message,
              },
            });
          });
      }
    },
  },
  mounted() {
    this.retrieveAccounts().catch((error) => {
      console.error('> failed to retrieve accounts for merge:', error);
    });
  },
};
</script>

<template>
  <b-modal
    id="modal-select-reference"
    ref="modal-select-reference"
    title="Select Account"
    cancel-variant="outline-secondary"
    footer-class="m-0 p-0"
    body-class="pt-0 pb-0"
    no-stacking
    centered
    :visible="isMergeOpen"
    @close="$emit('update:is-merge-open', false)"
  >
    <div>
      <div
        v-for="account in referenceAccounts"
        class="border rounded p-75 pl-1 d-flex flex-row align-items-center mb-75 cursor-pointer"
        @click="onAccountSelect(account.value, $event)"
        :key="account.id"
      >
        <feather-icon icon="FileTextIcon" size="16" class="mr-25" />
        <span class="text-weight-bold" style="margin-left: 2px">{{ account.label }}</span>
      </div>
    </div>

    <template #modal-footer>
      <div></div>
    </template>
  </b-modal>
</template>

<style scoped lang="scss"></style>
